"use strict";

import BaseModel from "dias/core/models/baseModel";

class FoerderdokumentAktiv extends BaseModel {
  constructor() {
    super("aktive_foerderdokumente");
  }
}

export default FoerderdokumentAktiv;
